import script from "./CoursesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CoursesPage.vue?vue&type=script&setup=true&lang=js"

import "./CoursesPage.vue?vue&type=style&index=0&id=74befa42&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74befa42"]])

export default __exports__